import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";

const pinListingMetadataFn = httpsCallable(functions, "pinListingMetadata");

export async function pinListingMetadata(listingId, metadata) {
  if (!listingId || typeof listingId !== "string") {
    throw new Error("listingId must be a non-empty string");
  }
  if (!metadata || typeof metadata !== "object" || Array.isArray(metadata)) {
    throw new Error("metadata must be a JSON object");
  }

  if (!metadata.image) {
    console.error("[IPFS Pin] ERROR: Attempting to pin metadata WITHOUT image field!");
    throw new Error("Cannot pin metadata without image field");
  }

  const response = await pinListingMetadataFn({ listingId, metadata });
  return response?.data;
}
